export default class Scales {
  constructor() {}
  checkIfChartHasScale(chart) {
    /**
     * Treat cases that don't have scale
     */
    if (!chart.amounts) {
      return false;
    }
    if (Array.isArray(chart.amounts) || !chart.amounts.scales || chart.amounts.scales.length === 0) {
      // Dont have scales
      return false;
    }

    return true;
  }
  /**
   * Get Max and min scales to show on chart
   */
  getScaleMinAndMax(scale) {
    const name = scale.name;
    if (!name) {
      return { min: -100, max: 100 };
    }
    const regex = /(\d-\d?\d)/;
    const match = regex.exec(name);
    if (!match[0]) return;
    const scalearray = match[0].split("-");
    if (!scalearray[0] || !scalearray[1]) return;
    return { min: scalearray[0], max: scalearray[1] };
  }
  mountActiveScaleForChart(scale, chart) {
    let filteredData = null;
    if (!scale) {
      return chart;
    }
    if (scale.datasets) {
      /** chart.js type */
      filteredData = {
        ...chart,
        amounts: {
          labels: chart.amounts.labels,
          datasets: scale.datasets
        }
      };
    } else {
      /** other types */
      filteredData = {
        ...chart,
        amounts: scale.amounts
      };
      if (scale.total_responses) {
        filteredData.total_responses = scale.total_responses;
      }
    }

    const { min, max } = this.getScaleMinAndMax(scale);
    if (min && max) {
      filteredData.min = min;
      filteredData.max = max;
    }
    return filteredData;
  }
}
